import { Component, Input, OnInit } from '@angular/core';
import { ObjetService } from 'src/app/service/objet.service';
import { PdfService } from 'src/app/service/pdf.service';
import { Context } from 'src/app/shared/services/context.service';
import * as pdfjsLib from 'pdfjs-dist';
import { BibagueTraitement } from 'src/app/service/bibague.service';
@Component({
  selector: 'app-bibagues',
  templateUrl: './bibagues.component.html',
  styleUrls: ['./bibagues.component.scss'],
})
export class BibaguesComponent implements OnInit {
  idUser: string;
  story: string = null;
  dateCreation: any;
  praticien: any;
  constructor(private objetService: ObjetService,private pdfService: PdfService, private bibagueTraitement:BibagueTraitement) { }
  @Input('currentDate') currentDate;
  @Input('userSelected') userSelected;
  @Input('ageString') ageString;
  @Input('traitementBibagueId') traitementBibagueId;
  @Input('traitementBibague') traitementBibague;
  @Input('showSummary') showSummary = false;
  @Input('listbibagueTreatement') listbibagueTreatement = [];

  
  ngOnInit() {
    let value = localStorage.getItem("currentUser");
    this.praticien = JSON.parse(value);
    this.idUser = localStorage.getItem("idPatient");
    console.log('this.idUser',this.idUser);
        if (this.traitementBibagueId) {
          console.log('traitementBibague',this.traitementBibague);
          this.isUrgent = this.traitementBibague.urgent;
          this.disjonctType = this.traitementBibague.disjonct ; 
          this.selectedOptions = this.traitementBibague.selectedOptions ;
          this.remarks = this.traitementBibague.remarks ;
          this.isReparation = this.traitementBibague.reparation ;
          this.remarks = this.traitementBibague.remarks ;
          this.story = this.traitementBibague.history ;
          this.dateCreation = this.traitementBibague.dateCreation;

          if (this.traitementBibague.quadHelix) {
              this.quadHelixSubOptions = this.traitementBibague.quadHelix.sousOptions || [];
              if (this.traitementBibague.quadHelix.pri) {
                this.quadHelixPriLength = this.traitementBibague.quadHelix.pri.longueur;
                this.quadHelixPriHeight = this.traitementBibague.quadHelix.pri.hauteur;
              }
            }

              // ---- ASI ----
            if (this.traitementBibague.asi) {
              this.asiEruption = this.traitementBibague.asi.eruption;
              this.asiSetup = this.traitementBibague.asi.setup;
            }

            // ---- Fil 3-3 Indirect ----
            if (this.traitementBibague.fil_3_3_indirect) {
              this.fil33Positions = this.traitementBibague.fil_3_3_indirect.positions;
              this.fil33Material = this.traitementBibague.fil_3_3_indirect.materiau;
            }

            // ---- Gouttières chirurgicales ----
            if (this.traitementBibague.gouttieres_chir) {
              this.gouttiereChirPositions = this.traitementBibague.gouttieres_chir.positions;
            }
          // ---- Gouttières de contention ----
            if (this.traitementBibague.gouttieres_contention) {
              this.selectedGouttiereOptions = [];

              if (this.traitementBibague.gouttieres_contention.maintiens) {
                this.selectedGouttiereOptions.push('maintiens');
                this.maintiensType = this.traitementBibague.gouttieres_contention.maintiens.type;
                this.maintiensDeStart = this.traitementBibague.gouttieres_contention.maintiens.deStart;
                this.maintiensDeEnd = this.traitementBibague.gouttieres_contention.maintiens.deEnd;
              }

              if (this.traitementBibague.gouttieres_contention.boutons) {
                this.selectedGouttiereOptions.push('boutons');
                this.boutonsOptions = this.traitementBibague.gouttieres_contention.boutons.types;
                this.boutonsDetails = this.traitementBibague.gouttieres_contention.boutons.details;
              }

              if (this.traitementBibague.gouttieres_contention.eruption) {
                this.selectedGouttiereOptions.push('eruption');
                this.eruptionOptions = this.traitementBibague.gouttieres_contention.eruption;
              }

              if (this.traitementBibague.gouttieres_contention.setup) {
                this.selectedGouttiereOptions.push('setup');
                this.setupDetails = this.traitementBibague.gouttieres_contention.setup;
              }

              if (this.traitementBibague.gouttieres_contention.facettes) {
                this.selectedGouttiereOptions.push('facettes');
                this.facettesDetails = this.traitementBibague.gouttieres_contention.facettes;
              }

              if (this.traitementBibague.gouttieres_contention.rigide) {
                this.selectedGouttiereOptions.push('rigide');
              }
              
            }

          


        }
  }
 bibaguesOptions = [
  { key: 'quad_helix', label: 'Quad Helix' },
  { key: 'arc_lingual', label: 'Arc Lingual' },
  { key: 'disjonct', label: 'Disjonct' },
  { key: 'gouttieres_contention', label: 'Gouttières de contention' },
  { key: 'asi', label: 'A.S.I' },
  { key: 'modele_3d', label: 'Modèle 3D' },
  { key: 'fil_3_3_indirect', label: 'Fil 3-3 Indirect' },
  { key: 'gouttieres_chir', label: 'Gouttières Chir' },
];

  objets = {
    pkObjet: 0,
    nom: "",
    extension: "",
    id_patient: 0,
    vignette: "",
    width: 0,
    height: 0,
    taille: 0,
    estidentite: 0,
    dateCreation: "",
    echelle: 0,
    fichier: "",
    lastModif: "",
    repStockage: "",
    syncPath: "",
    dateInsertion: "",
    auteur: "",
    idGabarit: "",
    id_patient_orthalis: "",
  };

selectedOptions: string[] = [];
remarks = '';
isUrgent = false;
isReparation = false;

toggleOption(key: string) {
  const index = this.selectedOptions.indexOf(key);
  if (index > -1) {
    this.selectedOptions.splice(index, 1);
  } else {
    this.selectedOptions.push(key);
  }
}

quadHelixSubOptions: string[] = [];

quadHelixPriLength = '';
quadHelixPriHeight = '';

toggleQuadHelixSubOption(option: string) {
  const index = this.quadHelixSubOptions.indexOf(option);
  if (index > -1) {
    this.quadHelixSubOptions.splice(index, 1);
  } else {
    this.quadHelixSubOptions.push(option);
  }
}

disjonctType: string = '';

selectDisjonctType(type: string) {
  this.disjonctType = type;
}

gouttiereChirPositions: string[] = [];

toggleGouttiereChir(pos: 'haut' | 'bas') {
  const index = this.gouttiereChirPositions.indexOf(pos);
  if (index > -1) {
    this.gouttiereChirPositions.splice(index, 1); // retirer si déjà sélectionné
  } else {
    this.gouttiereChirPositions.push(pos); // ajouter si pas encore
  }
}


fil33Positions: string[] = [];
fil33Material: 'or' | 'acier' | null = null;

toggleFil33Position(pos: 'haut' | 'bas') {
  const index = this.fil33Positions.indexOf(pos);
  if (index > -1) {
    this.fil33Positions.splice(index, 1);
  } else {
    this.fil33Positions.push(pos);
  }
}

asiEruption: string = '';
asiSetup: string = '';

getOptionLabel(key: string): string {
  const found = this.bibaguesOptions.find(opt => opt.key === key);
  return found ? found.label : key;
}
maintiensType: string = '';
maintiensDeStart: string = '';
maintiensDeEnd: string = '';
getOptionValue(key: string, item: any): string {
  switch (key) {
    case 'quad_helix': {
      const quadHelix = item.quadHelix || {};
      const subOptions: string[] = quadHelix.sousOptions || [];
      const pri = subOptions.includes('pri') && quadHelix.pri
        ? ` (Longueur: ${quadHelix.pri.longueur}, Hauteur: ${quadHelix.pri.hauteur})`
        : '';
      return subOptions.join(', ') + pri;
    }

    case 'disjonct': {
      return item.disjonct || '-';
    }

    case 'asi': {
      const asi = item.asi || {};
      return `Éruption: ${asi.eruption || '-'}, Setup: ${asi.setup || '-'}`;
    }


    case 'fil_3_3_indirect': {
      const fil = item.fil_3_3_indirect || {};
      const positions = fil.positions || [];
      return `Position: ${positions.join(', ')}, Matériau: ${fil.materiau || '-'}`;
    }

    case 'gouttieres_contention': {
      const g = item.gouttieres_contention || {};

      const maintiens = g.maintiens
        ? (g.maintiens.type === 'total'
            ? 'Maintiens: Total'
            : g.maintiens.type === 'de'
              ? `Maintiens: De ${g.maintiens.deStart} à ${g.maintiens.deEnd}`
              : '')
        : '';

      const boutons = g.boutons
        ? `Boutons: ${(g.boutons.choix || []).join(', ').toUpperCase()}${g.boutons.details ? ' (' + g.boutons.details + ')' : ''}`
        : '';

      const eruption = g.eruption ? `Éruption: ${g.eruption.join(', ')}` : '';
      const setup = g.setup ? `Setup: ${g.setup}` : '';
      const facettes = g.facettes ? `Facettes: ${g.facettes}` : '';
      const rigide = g.rigide ? 'Rigide: Oui' : '';

      return [maintiens, boutons, eruption, setup, facettes, rigide]
        .filter(val => val)
        .join(' \n ');
    }

    case 'arc_lingual': {
      return item.arc_lingual ? 'Oui' : '-';
    }

    case 'gouttieres_chir': {
      const pos = (item.gouttieres_chir && item.gouttieres_chir.positions) ? item.gouttieres_chir.positions : [];
      return pos.length
        ? `Gouttières Chirurgicales: ${pos.map(p => p === 'haut' ? 'Haut' : p === 'bas' ? 'Bas' : p).join(', ')}`
        : '-';
    }


    case 'modele_3d': {
      return item.modele_3d ? 'Oui' : 'Non';
    }

    default:
      return '-';
  }
}


getFilteredOptions(options: string[], item: any): string[] {
  return options.filter(opt => {
    const value = this.getOptionValue(opt, item);
    return value && value.trim() !== '-' && value.trim() !== '';
  });
}



gouttiereContentionSubOptions = [
  { key: 'maintiens', label: 'Maintiens' },
  { key: 'boutons', label: 'Boutons' },
  { key: 'eruption', label: 'Éruption' },
  { key: 'setup', label: 'Setup sur' },
  { key: 'facettes', label: 'Facettes' },
  { key: 'rigide', label: 'Rigide' }
];

selectedGouttiereOptions: string[] = [];

maintiensOption: 'total' | 'de' | null = null;
maintiensFrom: string = '';
maintiensTo: string = '';
facettesDetails: string = '';
setupDetails: string = '';
toggleGouttiereOption(key: string) {
  const index = this.selectedGouttiereOptions.indexOf(key);
  if (index > -1) {
    this.selectedGouttiereOptions.splice(index, 1);
  } else {
    this.selectedGouttiereOptions.push(key);
  }
}
boutonsOptions: string[] = []; // v, l
boutonsDetails: string = '';

// Pour "Éruption"
eruptionOptions: number[] = []; // 3, 4, 5


toggleBouton(value: string) {
  const index = this.boutonsOptions.indexOf(value);
  if (index > -1) {
    this.boutonsOptions.splice(index, 1);
  } else {
    this.boutonsOptions.push(value);
  }
}

toggleEruptionOption(value: number) {
  const index = this.eruptionOptions.indexOf(value);
  if (index > -1) {
    this.eruptionOptions.splice(index, 1);
  } else {
    this.eruptionOptions.push(value);
  }
}


  showSpinner: boolean = false;
  submit() {
    this.showSummary = true;
  }
submitSummary() {
  this.showSpinner = true;
  const summaryData: any = {
    idPatient : this.idUser,
    id : this.traitementBibagueId ,
    selectedOptions: this.selectedOptions,
    remarks: this.remarks,
    urgent: this.isUrgent,
    reparation: this.isReparation,
    quadHelix: this.selectedOptions.includes('quad_helix') ? {
      sousOptions: this.quadHelixSubOptions,
      pri: this.quadHelixSubOptions.includes('pri') ? {
        longueur: this.quadHelixPriLength,
        hauteur: this.quadHelixPriHeight
      } : null
    } : null,
    disjonct: this.disjonctType || null,
    asi: this.selectedOptions.includes('asi') ? {
      eruption: this.asiEruption,
      setup: this.asiSetup
    } : null,
    fil_3_3_indirect: this.selectedOptions.includes('fil_3_3_indirect') ? {
      positions: this.fil33Positions,
      materiau: this.fil33Material
    } : null,
    gouttieres_chir: this.selectedOptions.includes('gouttieres_chir') ? {
      positions: this.gouttiereChirPositions
    } : null,
    gouttieres_contention: this.selectedOptions.includes('gouttieres_contention') ? {
      maintiens: this.selectedGouttiereOptions.includes('maintiens') ? {
        type: this.maintiensType,
        deStart: this.maintiensDeStart,
        deEnd: this.maintiensDeEnd
      } : null,
      boutons: this.selectedGouttiereOptions.includes('boutons') ? {
        types: this.boutonsOptions,
        details: this.boutonsDetails
      } : null,
      eruption: this.selectedGouttiereOptions.includes('eruption') ? this.eruptionOptions : null,
      setup: this.selectedGouttiereOptions.includes('setup') ? this.setupDetails : null,
      facettes: this.selectedGouttiereOptions.includes('facettes') ? this.facettesDetails : null,
      rigide: this.selectedGouttiereOptions.includes('rigide') ? true : false
    } : null,
    modele_3d: this.selectedOptions.includes('modele_3d'),
    arc_lingual: this.selectedOptions.includes('arc_lingual'),
    history : this.story ,
    dateCreation : this.dateCreation ,
    typePlan: "Home Made",
    idPraticien: this.praticien.id

  };
    this.bibagueTraitement.addNewTreatments(summaryData).subscribe((response: Blob) => {
    console.log("response : ", response );
    this.lastbibagueTraitement = response ;
    // this.printPlanDeTraitement();
    // this.getPlantDeTraitement(this.idUser);
    this.getListBibagueTreatement();
      
    });
  console.log('Résumé JSON :', summaryData);
}

lastbibagueTraitement : any  = [ {
  "selectedOptions": [],
  "remarks": "",
  "dateCreation" :"",
  "urgent": false,
  "reparation": false,
  "quadHelix": {
    "sousOptions": [],
    "pri": null
  },
  "fil_3_3_indirect": {
    "positions": [],
    "materiau": null
  },
  "gouttieres_chir": {
    "positions": []
  },
  "gouttieres_contention": {
    "maintiens": null,
    "boutons": {
      "types": [],
      "details": null
    },
    "eruption": [],
    "setup": null,
    "facettes": null,
    "rigide": null
  },
  "modele_3d": false,
  "arc_lingual": true,
  "idPatient": 1027643
}]  



  getListBibagueTreatement() {
    console.log('lastbibagueTraitement', this.lastbibagueTraitement);
    
    this.bibagueTraitement.getAllTreatments(this.idUser).subscribe((response: any) => {
      console.log("response : ", response);
      console.log("listRccTreatement : ", this.listbibagueTreatement);
        for (let i = response.length - 1; i >= 0; i--) {
          this.listbibagueTreatement.push(response[i]);
        }
      // this.lastbibagueTraitement = this.listbibagueTreatement[0];
      console.log("response : ", response);

      this.showSpinner = false;
      this.showSummary = true;
    });
  }
  cancel() {
    this.showSummary = false;
  }

      insertObjet(
    nom,
    extension,
    id_patient1,
    vignette,
    width,
    height,
    taille,
    estidentite,
    dateCreation,
    echelle,
    fichier,
    lastModif,
    repStockage,
    syncPath,
    dateInsertion,
    auteur,
    idGabarit,
    id_patient_orthalis
  ) {
    this.objets["nom"] = nom;
    this.objets["extension"] = extension;
    this.objets["id_patient"] = id_patient1;
    this.objets["vignette"] = vignette;
    this.objets["width"] = width;
    this.objets["height"] = height;
    this.objets["taille"] = taille;
    this.objets["estidentite"] = estidentite;
    this.objets["dateCreation"] = dateCreation;
    this.objets["echelle"] = echelle;
    this.objets["fichier"] = fichier;
    this.objets["lastModif"] = lastModif;
    this.objets["repStockage"] = repStockage;
    this.objets["syncPath"] = syncPath;
    this.objets["dateInsertion"] = dateInsertion;
    this.objets["auteur"] = auteur;
    this.objets["idGabarit"] = idGabarit;
    this.objets["id_patient_orthalis"] = id_patient_orthalis;

    return this.objetService.addObjet(this.objets);
  }


    printPlanDeTraitement() {
      const printElement = document.getElementById('bibagueResume');
      if (printElement) {
        // Afficher l'élément en retirant l'attribut hidden
        printElement.hidden = false;
    
        // Créer une fenêtre d'impression
        const printWindow = window.open('', '_blank', "width="+ screen.width + ",height=" + screen.height);
        if (printWindow) {
          printWindow.document.write(`
            <html>
              <head>
                <title>Résumé du Plan de Traitement ${this.userSelected}</title>
                <style>
                   body {
                      font-family: Arial, sans-serif;
                      margin: 0;
                      padding: 0;
                      background-color: #f9f9f9;
                      color: #333;
                    }
                    .container {
                      width: 80%;
                      margin: 20px auto;
                      background: #fff;
                      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                      border-radius: 8px;
                      padding: 20px;
                    }
                    .header {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      margin-bottom: 20px;
                      border-bottom: 2px solid #58b3dd;
                      padding-bottom: 10px;
                    }
                    .header h1 {
                      color: #58b3dd;
                      font-size: 24px;
                      margin: 0;
                    }
                    .header .date {
                      font-size: 14px;
                      color: #777;
                    }
                    .section {
                      margin-bottom: 10px;
                      padding: 15px;
                      background-color: #f1f9ff;
                      border-left: 5px solid #58b3dd;
                      border-radius: 4px;
                    }
                    .section h2 {
                      font-size: 20px;
                      margin-bottom: 10px;
                      color: #333;
                    }
                    .section p {
                      margin: 5px 0;
                      line-height: 1.6;
                    }
                     th, td {
                    border: 1px solid #3b82f6;
                    padding: 8px;
                    text-align: center;
                    vertical-align: top;
                  }
              
                  th {
                    background-color: #f0f8ff;
                    font-weight: bold;
                  }
              
                  td {
                    white-space: pre-line;
                  }
                </style>
              </head>
              <body>${printElement.outerHTML}</body>
              <script type="text/javascript" defer>
                setTimeout(function() {
                    window.print();
                    window.close();
                }, 1000);
              </script>
            </html>
          `);
        }
        printWindow.document.close();
        // Réappliquer l'attribut hidden après impression
        printElement.hidden = true;
        this.downloadAsPdf();
      } else {
        console.error('Élément à imprimer introuvable.');
      }
    }
  
    downloadAsPdf() {
      var printContents = document.getElementById("bibagueResume").innerHTML;
      let html = `
            <html>
              <head>
                <title>Résumé du Plan de Traitement ${this.userSelected}</title>
                <style>
                   body {
                      font-family: Arial, sans-serif;
                      margin: 0;
                      padding: 0;
                      background-color: #f9f9f9;
                      color: #333;
                    }
                    .container {
                      width: 80%;
                      margin: 20px auto;
                      background: #fff;
                      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                      border-radius: 8px;
                      padding: 20px;
                    }
                    .header {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      margin-bottom: 20px;
                      border-bottom: 2px solid #58b3dd;
                      padding-bottom: 10px;
                    }
                    .header h1 {
                      color: #58b3dd;
                      font-size: 24px;
                      margin: 0;
                    }
                    .header .date {
                      font-size: 14px;
                      color: #777;
                    }
                    .section {
                      margin-bottom: 10px;
                      padding: 15px;
                      background-color: #f1f9ff;
                      border-left: 5px solid #58b3dd;
                      border-radius: 4px;
                    }
                    .section h2 {
                      font-size: 20px;
                      margin-bottom: 10px;
                      color: #333;
                    }
                    .section p {
                      margin: 5px 0;
                      line-height: 1.6;
                    }
                      th, td {
                        border: 1px solid #3b82f6;
                        padding: 8px;
                        text-align: center;
                        vertical-align: top;
                      }
                  
                      th {
                        background-color: #f0f8ff;
                        font-weight: bold;
                      }
                  
                      td {
                        white-space: pre-line;
                      }
                </style>
              </head>
              <body>${printContents}</body>
              <script type="text/javascript" defer>
                setTimeout(function() {
                    window.print();
                }, 1000);
              </script>
            </html>
          `;
  
            
      this.pdfService.htmlToPdf(html).subscribe((response: Blob) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        this.saveToBasePhoto(blob);
      });
    }
    isDisabled: boolean = false;
    isLoading: boolean = false;
    async saveToBasePhoto(blob: any) {
      // const arrayBuffer = await blob.arrayBuffer();
      // const destName = sha1(blob.text());
      const destName = "Bibague_" + localStorage.getItem('idPatient') + generateRandomString(12);
  
      pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js";
      const pdfDoc = await pdfjsLib.getDocument({ url: URL.createObjectURL(blob) }).promise.then(async (pdf) => {
        const page = await pdf.getPage(1);
        const canvas = document.createElement('canvas');
        const context = canvas.getContext("2d");
        const viewport = page.getViewport({ scale: 1 });
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const renderContext = {
          canvasContext: canvas.getContext('2d'),
          viewport: viewport,
        };
        await page.render(renderContext).promise.then( async () => {
          const imageDataURL = canvas.toDataURL('image/jpeg', 25);
          const image = imageDataURL.replace("data:image/jpeg;base64,", "");
          await this.insertObjet(
            destName + ".pdf", ".pdf", +localStorage.getItem('idPatient'), image, 141, 200, 0, 0, null, 1, destName + ".pdf", "", Context.folder + localStorage.getItem('idPatient'), "", "", "", 0, localStorage.getItem('idPatient')
          ).toPromise();
          this.isLoading = false;
          this.isDisabled = false;
  
        });
      });  
  
      var form = new FormData();
      form.append("file", blob);
      this.objetService
          .saveImage(destName + ".pdf", Context.folder + localStorage.getItem('idPatient'), form)
          .subscribe();
    }
}

function generateRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}
